import { Breadcrumb } from 'antd';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { routes } from '@/config/routes';

function titlecase(s: string) {
  return s
    .split('-')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}

export function Breadcrumbs() {
  const location = useLocation();

  const items = useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const crumbs = [{ title: <Link to={routes.dashboard}>Home</Link> }];
    let acc = '';
    segments.forEach((seg, i) => {
      acc += `/${seg}`;
      const isLast = i === segments.length - 1;
      crumbs.push({
        title: isLast ? <span>{titlecase(seg)}</span> : <Link to={acc}>{titlecase(seg)}</Link>,
      });
    });
    return crumbs;
  }, [location.pathname]);

  return <Breadcrumb items={items} />;
}
